import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "../../lib/api";
import { useLang } from "../../i18n";

const STATUSES = ["nuovo", "in_lavorazione", "spedito", "consegnato", "annullato"];

export default function OrdersAdmin() {
  const { t } = useLang();
  const [orders, setOrders] = useState([]);

  const load = () => api.get("/admin/orders").then((r) => setOrders(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const updateStatus = async (id, status) => {
    await api.patch(`/admin/orders/${id}`, { status }).catch(() => {});
    toast.success("✓");
    load();
  };

  return (
    <div data-testid="admin-orders">
      <h1 className="font-serif text-3xl font-bold">{t("admin.orders")}</h1>
      <div className="mt-8 space-y-4">
        {orders.length === 0 && <p className="text-slate-500 text-sm" data-testid="orders-admin-empty">—</p>}
        {orders.map((o) => (
          <div key={o.id} className="bg-slate2 border border-slate-700 rounded-lg p-6" data-testid={`admin-order-${o.id}`}>
            <div className="flex flex-wrap items-start justify-between gap-4">
              <div>
                <p className="font-mono text-xs text-slate-500">#{o.id.slice(0, 8)} · {new Date(o.created_at).toLocaleString("it-IT")}</p>
                <p className="mt-1 font-medium text-slate-100">{o.customer?.name} — {o.customer?.email}</p>
                <p className="text-sm text-slate-400">{o.customer?.address}, {o.customer?.city} {o.customer?.zip}</p>
                <ul className="mt-3 space-y-1 text-sm text-slate-300">
                  {o.items.map((it, i) => (
                    <li key={i}>· {it.name_it} ({it.size}) ×{it.qty} — <span className="font-mono text-gold">€{(it.price * it.qty).toFixed(2)}</span></li>
                  ))}
                </ul>
              </div>
              <div className="text-right space-y-2">
                <p className="font-mono text-xl font-semibold text-gold">€{o.total.toFixed(2)}</p>
                <p className={`text-xs font-mono ${o.payment_status === "paid" ? "text-green-400" : "text-slate-500"}`} data-testid={`order-payment-${o.id}`}>
                  {o.payment_status === "paid" ? "PAGATO" : "NON PAGATO"}
                </p>
                <select value={o.status} onChange={(e) => updateStatus(o.id, e.target.value)} data-testid={`order-status-select-${o.id}`}
                  className="bg-obsidian border border-slate-600 text-sm text-slate-100 px-3 py-2 focus:outline-none focus:border-gold">
                  {STATUSES.map((s) => <option key={s} value={s}>{t(`order.status.${s}`)}</option>)}
                </select>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
